<template>
    <b-container fluid class="supplement-prompt-management py-4">
        <div class="mb-3">
            <h4 class="mb-1">AI 판단 기준 관리</h4>
            <p class="text-muted mb-0">
                보완검토에서 남긴 피드백을 AI 의 판단 기준에 반영합니다.
                반영한 내용은 버전으로 저장되며, 적용하면 약 1분 내에 이후 판정부터 반영됩니다.
            </p>
        </div>

        <b-card no-body>
            <b-tabs v-model="tabIndex" card>
                <b-tab title="피드백 인박스" lazy>
                    <FeedbackInboxTab />
                </b-tab>
                <b-tab title="버전 이력" lazy>
                    <AssetVersionsTab @check-gate="tabIndex = 2" />
                </b-tab>
                <b-tab title="수렴 지표" lazy>
                    <MetricsTab />
                </b-tab>
            </b-tabs>
        </b-card>
    </b-container>
</template>

<script>
import FeedbackInboxTab from './FeedbackInboxTab.vue';
import AssetVersionsTab from './AssetVersionsTab.vue';
import MetricsTab from './MetricsTab.vue';

export default {
    name: 'SupplementPromptManagement',
    components: {FeedbackInboxTab, AssetVersionsTab, MetricsTab},
    data() {
        return {
            tabIndex: 0,
        };
    },
};
</script>

<style scoped>
.supplement-prompt-management h4 {
    font-weight: 700;
}
</style>
